import { Button } from "@/shared/components/ui/button";
import { RefreshCw } from "lucide-react";
import { ComponentProps } from "react";

export function CommonSubmitButton({
  children,
  onClick,
  isLoading,
  disabled,
  ...props
}: ComponentProps<"button"> & { isLoading: boolean }) {
  return (
    <Button onClick={onClick} disabled={disabled || isLoading} {...props}>
      {isLoading && <RefreshCw className="size-4 animate-spin" />}
      {children}
    </Button>
  );
}
